module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9a32Ju/tc-custom/9781637414057.jpg?1732274355173",
      "alt": "This image is the cover for the book Brunch"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Brunch\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Whatever your reasons for brunching, this cookbook covers all your options—from hangover-curing Chorizo-Stuffed Tortillas to healthy fruit smoothies.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Brunch is a meal that combines both breakfast and lunch, eaten around midday or late in the morning, on lazy days off. Brunch is an incredibly versatile meal. This book includes chapters on Breads and Pastries, Cereal, Eggs, Fruit, Meat, Fish, Vegetarian and Drinks. With over eighty sumptuous recipes for traditional savoury and sweet brunches, this book will provide the perfect start to the day."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Pour yourself a Bloody Mary and whip up:"), _c('br'), _vm._v("    Swiss Yoghurt-Soaked Muesli  Raspberry and Banana Muffins  Danish Open Sandwich  Mushroom Crostini  Mexican Scrambled Eggs  Spicy Sausage Patties  Challah French Toast with Berries  Parmesan Crusted Asparagus and Poached Egg  And much more \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joy Skipper\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    New Holland\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0